import Skeleton from "react-loading-skeleton";

const CocoSkeleton = () => {
  return (
    <>
      <Skeleton height={40} enableAnimation={true} />

      <table className="table loading-table">
        <tbody>
          {[1, 2, 3, 4, 5, 6, 7, 8]?.map((row) => (
            <tr key={row}>
              {[1, 2]?.map((column, index) => (
                <td
                  style={{
                    width: index === 0 ? "150px" : "600px",
                  }}
                  key={column}
                >
                  <Skeleton animation="wave" variant="text" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default CocoSkeleton;
